"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.create.title': 'Create New Branch',
};
